import { buildContractPath } from "./api/contract-client.js";

export const PLATFORM_CONTROL_TIMEOUT_MS = 20000;

export function buildGetFederationMetricsPath(query = {}) {
  return buildContractPath("get__federation_metrics", { query });
}

export function buildGetFederationTenantsPath(query = {}) {
  return buildContractPath("get__federation_tenants", { query });
}

export function buildPostFederationConsentPath() {
  return buildContractPath("post__federation_consent");
}

export function buildGetSaPlatformDomainsPath() {
  return buildContractPath("get__sa_platform_domains");
}

export function buildPostSaDevicesCustodyPath() {
  return buildContractPath("post__sa_devices_custody");
}

export function buildGetSaNotificationGroupSharesPath(query = {}) {
  return buildContractPath("get__sa_notification-groups_shares", { query });
}

export function buildGetSharesPath() {
  return buildContractPath("get__shares");
}

export function buildPostSharesKeysPath() {
  return buildContractPath("post__shares_keys");
}

export function buildPostSharesRedeemPath() {
  return buildContractPath("post__shares_redeem");
}

export function buildDeleteSharePath(shareId) {
  return buildContractPath("delete__shares_p", { pathParams: [shareId] });
}

export function buildGetAdminSecurityAuditPath(query = {}) {
  return buildContractPath("get__admin_security_audit", { query });
}

export function buildPostAdminSecurityRotateCmdKeyPath() {
  return buildContractPath("post__admin_security_rotate-cmd-key");
}

export function buildGetSaMacDriftPath(query = {}) {
  return buildContractPath("get__sa_security_mac-drift", { query });
}

export function buildGetAdminBackupSchedulePath() {
  return buildContractPath("get__admin_backup_schedule");
}

export function buildPostAdminBackupRestoreDrillPath() {
  return buildContractPath("post__admin_backup_restore-drill");
}

export function buildGetHealthStatusPath() {
  return buildContractPath("get__health_status");
}

export function buildGetHealthAlertsPath(query = {}) {
  return buildContractPath("get__health_alerts", { query });
}

export function buildGetSopPath(query = {}) {
  return buildContractPath("get__sop", { query });
}

export function buildPostSopPath() {
  return buildContractPath("post__sop");
}

export function buildPostSopFeedbackPath(sopId) {
  return buildContractPath("post__sop_p_feedback", { pathParams: [sopId] });
}

export function buildGetSopRecommendationsPath(query = {}) {
  return buildContractPath("get__sop_recommendations", { query });
}

export function buildGetDevicesCapabilitiesPath(query = {}) {
  return buildContractPath("get__devices_capabilities", { query });
}

export function buildPostDeviceCapabilitiesPath(deviceId) {
  return buildContractPath("post__devices_p_capabilities", { pathParams: [deviceId] });
}

export function buildPostExportControlJobPath() {
  return buildContractPath("post__export-control_jobs");
}

export function buildGetExportControlJobPath(jobId) {
  return buildContractPath("get__export-control_jobs_p", { pathParams: [jobId] });
}

export function buildPostExportControlDownloadTokenPath(jobId) {
  return buildContractPath("post__export-control_jobs_p_download-token", { pathParams: [jobId] });
}

export function buildGetExportControlDownloadPath(jobId) {
  return buildContractPath("get__export-control_jobs_p_download", { pathParams: [jobId] });
}

export function buildGetExportControlDownloadPresignedPath(jobId) {
  return buildContractPath("get__export-control_jobs_p_download-presigned", { pathParams: [jobId] });
}
